import { ThunkAction, AnyAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '..';
import { getConfig } from '../../common/config';
import { FormFields, Coords, ValueOf } from '../../common/types';
import {
    generateCode,
    setField,
    setAvailableTariffs,
    setShortUrl,
    setShortUrlLoading,
    setShortUrlFailed,
} from '.';

let abortControler: AbortController | null = null;

export const fetchShortUrl =
    (): ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch, getState) => {
        const { generatedUrl, fields } = getState().form;
        const { generatedUrlPostfix } = getConfig(fields.app);

        if (abortControler) {
            abortControler.abort();
        }
        abortControler = new AbortController();

        dispatch(setShortUrlLoading());
        try {
            const url = generatedUrl + generatedUrlPostfix;
            const response = await axios.get(`https://clck.ly/--?url=${encodeURIComponent(url)}`, {
                signal: abortControler?.signal,
            });
            dispatch(setShortUrl(response.data));
        } catch (error) {
            if (!axios.isCancel(error)) {
                dispatch(setShortUrlFailed());
            }
        } finally {
            if (abortControler) {
                abortControler = null;
            }
        }
    };

export const updateField =
    (
        name: keyof FormFields,
        value: ValueOf<FormFields>
    ): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch(setField({ name, value }));
        if (name === 'lang') window.localStorage.setItem('lang', value as string);
        dispatch(generateCode());
        dispatch(fetchShortUrl());
    };

export const fetchTariffs =
    (coords: Coords): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        const url =
            `https://taxi-routeinfo.taxi.yandex.net/zone_info?clid=` +
            `tech20200806&apikey=ae2a1fed899d4cb2a408cd0ca9913728&ll=${coords.lon},${coords.lat}`;
        const {
            data: { tariffs: rawTariffs },
        } = await axios.get(url);
        const tariffs = [];
        const available = new Set(['econom', 'business', 'minivan', 'vip']);
        for (let i = 0; i < rawTariffs.length; i += 1) {
            const { name } = rawTariffs[i];
            if (available.has(name)) tariffs.push(name);
        }
        dispatch(setAvailableTariffs(tariffs));
    };

export const updateCoords =
    (coords: Coords): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        if (coords.lat === '' || coords.lon === '') {
            return;
        }
        dispatch(updateField('addressCoords', coords));
        dispatch(fetchTariffs(coords));
    };
